import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Aangifte, BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-ab-inkomen',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-ab-inkomen.component.html',
  styleUrl: './tekst-ab-inkomen.component.scss',
})
export class TekstAbInkomenComponent implements OnInit {

  @Input() public id!: string;
  public ibAangifte = {} as Aangifte;
  public focusedElementId: string | null = null;
  public year = 2024;
  public actualYear: number = new Date().getFullYear();


  constructor(
      public dataService: BokkzIbDataService) {
  }

  ngOnInit(): void {
    this.dataService.incomeTaxEntity.subscribe((value) => {
      if (value.year !== undefined) {
        this.year = value.year;
      }
    })
  }

}

